import React, { useState, useEffect } from "react";
import { Card, Row, Col } from "antd";
import {
  UserOutlined,
  SolutionOutlined,
  ToolOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import InventoryIcon from "@mui/icons-material/Inventory";
import { Typewriter } from "react-simple-typewriter";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import "./Home.css";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { URL } from "../config";

const HomePage = () => {
  const navigate = useNavigate();
  const [ads, setAds] = useState([]);

  const cards = [
    { title: "Customer List", icon: <UserOutlined />, path: "/dashboard/customer-list" },
    { title: "Appointment List", icon: <EventAvailableIcon />, path: "/dashboard/appointment-booking-list" },
    { title: "Installation List", icon: <SolutionOutlined />, path: "/dashboard/installation-list" },
    { title: "Product List", icon: <InventoryIcon />, path: "/dashboard/product-list" },
    { title: "Technician List", icon: <ToolOutlined />, path: "/dashboard/technician-list" },
    { title: "Logout", icon: <LogoutOutlined />, path: "/" },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await axios.get(`${URL}/advertisements`);
        setAds(res.data || []);
      } catch (err) {
        console.error("Failed to fetch advertisements", err);
      }
    };
    fetchAds();
  }, []);

  return (
    <div className="container">
 
      <div className="header-card">
        <div className="header-content">
          <h2 className="welcome-text">
            <Typewriter
              words={["Eagle Eye Surveillance System"]}
              loop={0}
              cursor
              cursorStyle="_"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </h2>
        </div>
      </div>

    
      <div className="slider-container">
        <Slider {...sliderSettings}>
          {ads.map((ad) => (
            <div key={ad.advertisementId}>
              <img src={`${URL}${ad.advertisementImage}`} alt={`Ad ${ad.advertisementId}`} className="ad-image" />
            </div>
          ))}
        </Slider>
      </div>

      <Row
        gutter={[16, 16]}
        justify="center"
        align="middle"
        style={{ marginTop: "30px" }}
      >
        {cards.map((card, idx) => (
          <Col xs={12} sm={12} md={6} lg={4} key={idx}>
            <Card
              className="action-card"
              hoverable
              onClick={() => (card.path === "/" ? window.location.href = "/" : navigate(card.path))}
            >
              <div className="card-icon">{card.icon}</div>
              <div className="card-text">{card.title}</div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default HomePage;
